import { Box, Typography } from "@mui/material";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import TkTitle from "../../../../atoms/TkTitle";
import { banks } from "../../../../../assets/data/Constants";
import TkButton from "../../../../atoms/TkButton";
import { transposedHiragana } from "../../../../../assets/data/Constants";
import "./_style.scss";
import { TkSelectForm } from "../../../../atoms/TkSelectForm";
import { TkBankSelectionContext } from "../../context";
import { IFinancialInstitutionSelectionProps } from "../../../../../type/componentsType/TkBankSelection";
import { httpGetBankList } from "../../api/request";
import { isMobileDevice } from "../../../../../utils/useTools";
import TkLabelText from "../../../../atoms/TkLabelText";
import _ from "lodash";

/**
 * 金融機関選択コンポーネント
 * @param {IFinancialInstitutionSelectionProps} props - 金融機関選択コンポーネントのプロパティ
 * @param {Function} props.onClose - 金融機関選択コンポーネントを閉じるためのコールバック関数
 */
const FinancialInstitutionSelection: React.FC<
  IFinancialInstitutionSelectionProps
> = (props) => {
  const { onClose } = props;
  const [selectBank, setSelectBank] = React.useState<any[]>([]);
  const [selectedBankCode, setSelectedBankCode] = React.useState<string>("");
  const [currentHiragana, setCurrentHiragana] = React.useState<string | null>(
    null
  );

  const { state, setState } = useContext(TkBankSelectionContext);
  // スマホ判断
  const isMobile = isMobileDevice();
  const [mobileErrorMessggess, setMobileErrorMessggess] = useState<any>("");
  const mobileInputRef = useRef<string>("");
  const mobileInputDebounce = useRef(
    _.debounce((e: any) => {
      handleMobileSearch(e);
    }, 200)
  );

  // 濁音・半濁音の変換
  const SeionEnum = Object.freeze({
    が: "か",
    ぎ: "き",
    ぐ: "く",
    げ: "け",
    ご: "こ",
    ざ: "さ",
    じ: "し",
    ず: "す",
    ぜ: "せ",
    ぞ: "そ",
    だ: "た",
    ぢ: "ち",
    づ: "つ",
    で: "て",
    ど: "と",
    ば: "は",
    び: "ひ",
    ぶ: "ふ",
    べ: "へ",
    ぼ: "ほ",
    ぱ: "は",
    ぴ: "ひ",
    ぷ: "ふ",
    ぺ: "へ",
    ぽ: "ほ",
  });

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    // 銀行リストをセットアップする
    const selectPropsList: any[] = [];

    if (state.selectBankValue) {
      const res = await httpGetBankList({
        bankNameKana: state.selectBankValue,
      });

      res?.bankList && res?.bankList.length
        ? setSelectBank(
            res?.bankList.map((bank) => {
              return {
                value: bank.bankCd,
                label: bank.bankName,
                kana: bank.bankNameKatakana,
              };
            })
          )
        : setSelectBank([]);
      setSelectedBankCode(state.bankCode ? state.bankCode : "");
      setCurrentHiragana(state.selectBankValue);
    } else {
      setSelectBank(selectPropsList);
    }
  };

  useEffect(() => {
    // 選択された銀行コードに基づいて銀行情報を更新する
    const selBank = selectBank.find((bank) => bank.value === selectedBankCode);
    if (!selBank) return;

    const selBankNew = {
      bankCode: selBank.value,
      bankName: selBank.label,
      bankNameKatakana: selBank.kana,
    };

    setState({
      ...state,
      ...selBankNew,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBankCode]);

  const handleOnGetValue = (event: any, name?: string, kana?: string) => {
    if (name) {
      // 選択された銀行情報を更新する
      const selBankNew = {
        bankCode: event,
        bankName: name,
        bankNameKatakana: kana,
      };

      setState({
        ...state,
        ...selBankNew,
        step: 1,
        selectBranchValue: "",
      });
    }
    setSelectedBankCode(event);
  };

  const handleOnSearchValue = async (event?: any, other?: boolean) => {
    try {
      setCurrentHiragana(event);

      if (other) {
        // その他の銀行をフィルタリングする
        const filteredBanks = banks.filter((bank) =>
          /^[A-Za-z]/.test(bank?.bankName)
        );
        setSelectBank(
          filteredBanks.map((bank) => {
            return {
              value: bank.bankCode,
              label: bank.bankName,
              kana: bank.bankNameKatakana,
            };
          })
        );
      }

      const res = await httpGetBankList({ bankNameKana: event });

      res?.bankList && res?.bankList.length
        ? setSelectBank(
            res?.bankList.map((bank) => {
              return {
                value: bank.bankCd,
                label: bank.bankName,
                kana: bank.bankNameKatakana,
              };
            })
          )
        : setSelectBank([]);
    } catch (error) {
      console.error(error);
    }
  };

  const convertToSeion = (char: string) => {
    if (char in SeionEnum) {
      return SeionEnum[char as keyof typeof SeionEnum];
    }
    return char;
  };

  const handleMobileSearch = (e: any) => {
    const returnValue = e.target.value;
    if (returnValue === mobileInputRef.current) return;

    if (returnValue === "") {
      mobileInputRef.current = "*";
      setMobileErrorMessggess("");
      return;
    }

    mobileInputRef.current = returnValue;

    const hiraganaPattern = /^[\u3040-\u309F]+$/;

    if (hiraganaPattern.test(returnValue)) {
      setMobileErrorMessggess("");
      mobileInputRef.current = convertToSeion(returnValue);
    } else {
      setMobileErrorMessggess("ひらがな1文字で入力してください");
    }
  };

  return (
    <Box className="financialInstitutionSelection">
      {/* PC */}
      {!isMobile && (
        <>
          <TkTitle size="medium">
            1.
            金融機関名を選択してください。他の金融機関の場合は2に進んでください。
          </TkTitle>
          <Box className="button">
            {banks.map((bank) => {
              return (
                <TkButton
                  sx={{ textTransform: "none" }}
                  onClick={() =>
                    handleOnGetValue(
                      bank.bankCode,
                      bank.bankName,
                      bank.bankNameKatakana
                    )
                  }
                  className="bank"
                  key={bank.bankCode}
                >
                  {bank.bankName}
                </TkButton>
              );
            })}
          </Box>

          <TkTitle size="medium">2. 金融機関を検索してください。</TkTitle>
          <Box className="button">
            {transposedHiragana.map((hiragana, hIndex) => {
              return hiragana.map((item, index) => {
                return (
                  <TkButton
                    onClick={() => item && handleOnSearchValue(item)}
                    className="hina"
                    variant={
                      currentHiragana === item ? "outlined" : "contained"
                    }
                    key={`${hIndex}-${index}`}
                  >
                    {item ? item : "　"}
                  </TkButton>
                );
              });
            })}
            <TkButton
              className="other"
              onClick={() => handleOnSearchValue("*", true)}
              variant={currentHiragana === "*" ? "outlined" : "contained"}
            >
              その他
            </TkButton>
          </Box>
        </>
      )}

      {/* スマホ */}
      {isMobile && (
        <Box className="phoneBord">
          <TkTitle className="title" size="medium">
            金融機関の頭文字をひらがなで入力して「検索」ボタンを押してください。
          </TkTitle>

          <Box className="searchInput">
            <Box className="kanaSec">
              <TkLabelText
                className="kanaInput"
                inputProps={{ maxLength: 1 }}
                onChange={(e) => mobileInputDebounce.current(e)}
                error={!!mobileErrorMessggess}
                helperText={mobileErrorMessggess}
                size="medium"
              ></TkLabelText>
              <TkButton
                onClick={() => {
                  if (mobileErrorMessggess) return;
                  if (mobileInputRef.current === "") {
                    mobileInputRef.current = "*";
                  }
                  if (mobileInputRef.current.length > 1) return;
                  handleOnSearchValue(
                    mobileInputRef.current,
                    mobileInputRef.current === "*"
                  );
                }}
                size="large"
              >
                検索
              </TkButton>
            </Box>

            <Box>件数：{selectBank.length}件</Box>
          </Box>
          <Box>
            <Typography>
              ※金融機関名が英字から始まる場合は、空欄のまま「検索」ボタンを押してください。
            </Typography>
          </Box>
        </Box>
      )}

      <Box className={`${!isMobile ? "select" : "select mobile"}`}>
        <TkTitle className="title" size="medium">
          {!isMobile
            ? "金融機関を選択して「選択」ボタンをクリックしてください。"
            : "金融機関を選択して「選択」ボタンを押してください。"}
        </TkTitle>
        <TkSelectForm
          wantToSetValue={selectedBankCode}
          onGetValue={handleOnGetValue}
          minW="250px"
          variant="outlined"
          selectPropsList={selectBank}
          disabled={!(Array.isArray(selectBank) && selectBank.length !== 0)}
        />
      </Box>

      <Box className="moveButton">
        <TkButton
          size="large"
          onClick={() => {
            setSelectBank([]);
            setSelectedBankCode("");
            setState({});
            onClose && onClose();
          }}
        >
          戻る
        </TkButton>
        <TkButton
          disabled={!selectedBankCode}
          onClick={() => {
            setState({
              ...state,
              step: 1,
              selectBankValue: currentHiragana ? currentHiragana : "*",
              selectBranchValue: "",
            });
          }}
          size="large"
          ml
        >
          選択
        </TkButton>
      </Box>
    </Box>
  );
};

export default FinancialInstitutionSelection;
